module.exports = __webpack_public_path__ + "media/images/phone-1a577771362dd423cccb145481020c31.svg";